import SuperRepository from '../superRepository';

export default new class FileRepository extends SuperRepository {
  baseUri () {
    return 'file';
  }
  post = async (data, params) => this.httpClient().postFile(this.baseUri(), data, params);
}
